import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { logDevError, updateErrorMessage } from 'shared/alerts';

export const RELEASE_BEST_AVAILABLE = gql`
  mutation ReleaseBestAvailable($input: ReleaseBestAvailableInput!) {
    releaseBestAvailable(input: $input)
  }
`;

export function useReleaseBestAvailable() {
  const [releaseBestAvailableMutation] = useMutation(RELEASE_BEST_AVAILABLE);

  const releaseBestAvailable = useCallback(
    async (input) => {
      try {
        const response = await releaseBestAvailableMutation({
          variables: { input },
          onError: () => updateErrorMessage('Error releasing seats'),
        });

        return response;
      } catch (error) {
        logDevError(error);
        updateErrorMessage('Error releasing seats');
      }
    },
    [releaseBestAvailableMutation]
  );

  return releaseBestAvailable;
}
